import React, { useState, useEffect } from "react";
import { Recaptcha } from "../Recaptcha/Recaptcha.jsx";
import ValidatedTextInput from "../ValidatedTextInput/ValidatedTextInput.jsx";
import "./styles.scss";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

const CompanyConnectionRequestModal = (props) => {
  let [note, setNote] = useState("");
  let [linkedinUrl, setLinkedinUrl] = useState("");
  let [pending, setPending] = useState(false);
  let [buttonDisabled, setButtonDisabled] = useState(false);
  let [showLinkedinInput, setShowLinkedinInput] = useState(false);

  const validLinkedinTest = (string) => {
    return RegExp(
      "^https?://((www|ww).)?linkedin.com/((in/[^/]+/?)|(pub/[^/]+/((w|d)+/?){3}))$"
    ).test(string);
  };

  const handleSendConnectionRequest = async (note, linkedinUrl) => {
    if (linkedinUrl) {
      let patchedUser = [];
      try {
        patchedUser = await axios.patch("/api/v2/users/" + props.userId, {
          patch: { linkedin_url: linkedinUrl },
        });
      } catch (err) {
        console.log(err.stack);
      }
    }
    let result = await axios.post(
      "/api/v2/companies/" + props.company.project_id + "/connection_requests",
      {
        user_id: props.userId,
        note: note,
      }
    );

    props.handleClose(true);
  };

  let ctaString = "";
  let noteString = "";

  noteString = props.company.display_name
    ? "Note to " + props.company.display_name
    : "";

  ctaString = props.company.display_name
    ? props.company.display_name + " is"
    : "";
  return (
    <Modal
      className={"ps-connection-request-modal"}
      show={props.show && !!props.company.project_id}
      onHide={() => {
        props.handleClose(false);
      }}
      centered
      keyboard
    >
      <div
        className="ps-connection-request-modal__cancel-icon-container"
        onClick={() => {
          props.handleClose(false);
        }}
      >
        <img
          className="ps-connection-request-modal__cancel-icon"
          src="/images/icons/black-x-mark.svg"
        />
      </div>
      <div>
        <div className={"ps-connection-request-modal__title-box"}>
          <div className={"ps-connection-request-modal__logo-box"}>
            {props.company && (
              <img
                className={"ps-connection-request-modal__secondary-logo"}
                src={props.company.logo_url}
                alt=""
              />
            )}
          </div>
          <span className={"ps-connection-request-modal__title"}>
            Add a note
          </span>
          <span className={"ps-connection-request-modal__subtitle"}>
            {ctaString} more likely approve your request if they know who you
            are and how you can help
          </span>
        </div>
      </div>
      <hr />
      <div>
        <div className={"ps-connection-request-modal__content-box"}>
          <div className={"mb-1 d-flex flex-column"}>
            <label htmlFor="">{noteString}</label>
            <textarea
              disabled={pending}
              className={
                note.length === 500
                  ? "input-textarea--primary ps-connection-request-modal__input ps-connection-request-modal__input--full"
                  : "input-textarea--primary ps-connection-request-modal__input"
              }
              value={note}
              onChange={(e) => {
                setNote(e.target.value);
              }}
              maxLength="500"
              name=""
              id=""
              cols="30"
              rows="10"
            />
            <span
              className={
                note.length === 500
                  ? "ps-track-request-note-count ps-track-request-note-count--full"
                  : "ps-track-request-note-count"
              }
            >
              {note.length}/500
            </span>
          </div>
          {showLinkedinInput && (
            <div className={"form-group"}>
              <ValidatedTextInput
                placeholder="Your Linkedin URL"
                type="url"
                name="linkedin_url"
                errorMessage={"Please enter a valid LinkedIn URL"}
                validator={validLinkedinTest}
                handleInputChange={(e) => {
                  setLinkedinUrl(e.target.value);
                }}
                value={linkedinUrl}
                displayName={"Linkedin URL"}
                inputClassNames={
                  "input-text--primary ps-connection-request-modal__input"
                }
              />
            </div>
          )}
        </div>
      </div>
      <div className={"ps-connection-request-modal__footer-box"}>
        <React.Fragment>
          {pending && (
            <button className="btn ps-btn--primary ps-btn--full" disabled>
              Pending
            </button>
          )}
          {!pending && (
            <React.Fragment>
              <button
                disabled={buttonDisabled}
                className={"btn ps-btn--primary ps-btn--full"}
                onClick={async () => {
                  setButtonDisabled(true);
                  try {
                    await handleSendConnectionRequest(note, linkedinUrl);
                  } catch (error) {
                    toast.warning('Unable to send request. Please try again.')
                  }
                  setButtonDisabled(false);
                }}
              >
                Submit →
              </button>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    </Modal>
  );
};

module.exports.CompanyConnectionRequestModal = CompanyConnectionRequestModal;
